"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.WIDTHS = void 0;
exports.WIDTHS = {
    app: '1024px',
    textContent: '720px',
    navigationMain: '180px',
    navigationConfiguration: '230px',
};
//# sourceMappingURL=widths.js.map